import dotOrange from '../../images/dot-orange.webp';
import dotGrey from '../../images/dot-grey.webp';

export default (ctx, html) => html`
<div class="carousel-image">
  ${renderImages(ctx, html)}
</div>
<div class="carousel-btns disable-user-select">
  <a role="button" class="carousel-prev mx-3 my-2 mr-4 ${ctx.selectedIndex === 0 ? 'invisible' : 'visible'}" @click="${ctx.prevItem}"></a>
  ${html`${renderButtons(ctx, html)}`}
  <a role="button" class="carousel-next mx-3 my-2 ml-4 ${ctx.selectedIndex === ctx.config.items.length - 1 ? 'invisible' : 'visible'}" @click="${ctx.nextItem}"></a>
</div>
`;

const renderButtons = (ctx, html) => {
  return ctx.config.items.map((item, index) => {
    const isSelected = ctx.selectedIndex === index;
    const src = isSelected ? dotOrange : dotGrey;
    return html`
      <div class="carousel-dot-btn mx-3 my-2">
        <img src="${src}" @click="${(e) => ctx.selectIndex(index, true)}">
      </div>
    `;
  });
};

const renderImages = (ctx, html) => {
  return ctx.config.items.map((item, index) => {
    const className = ctx.selectedIndex === index ? 'visible in' : 'invisible';
    return html`<img src="${item}" class="${className} fade">`;
  });
};
